import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const BookFilled: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.14258 2C1.14258 0.895431 2.03801 0 3.14258 0H13.1426C14.0893 0 14.8569 0.767512 14.8569 1.71429V10.5714C14.8569 11.4209 14.239 12.1259 13.4283 12.2621V14.2857H13.9997C14.4731 14.2857 14.8569 14.6695 14.8569 15.1429C14.8569 15.6162 14.4731 16 13.9997 16H3.85686C2.3578 16 1.14258 14.7848 1.14258 13.2857V2ZM3.85686 14.2857H11.714V12.2857H3.85686C3.30458 12.2857 2.85686 12.7335 2.85686 13.2857C2.85686 13.8379 3.30458 14.2857 3.85686 14.2857Z"
      fill="currentColor"
    />
  </svg>
);
